export const DYNAMICIN_FORMATION = 18 // 企业资讯tabid
export const DYNAMIC_ACTIVITY = 19 // 文化活动tabid
